.container {
    background-color: var(--color-black);
    padding: 80px;
    text-align: center;
}

.header {
    font-size: clamp(2.75rem, 7vw, 3.75rem);
    color: var(--color-white);
    padding-inline: 1rem;
    text-transform: uppercase;
}
